import React from 'react'
import Text from '../../Text'
import { guidancePageContant } from '../../../config/pageContent'
import Flippingcard from '../../Flippingcard'
import Image from '../../Image'
import classNames from 'classnames'

interface Props {
    title?: string | JSX.Element | JSX.Element[],
    titleClassName?: string;
    CardsList?: Array<any>,
    containerClassName? : string,
    bottomClasses? : string,
    cardContainerClass? : string,
    containerCardClasses?: string,
    backSideClass?: string,
    cardContainerImageClass?: string,
    cardBackClass?: string
}

const Face2 = ({cardContainerClass,cardBackClass, backSideClass,cardContainerImageClass,containerCardClasses,containerClassName,bottomClasses,title=guidancePageContant.Face2.howCareerGuidance, titleClassName, CardsList= guidancePageContant.Face2.careerGuidance} : Props) => {
  return (
    <div className={classNames(containerClassName,'pt-[89px] z-10 ')}>
    <div>
      <Text className={classNames(titleClassName,'text-[62px] font-extrabold w-1/3 relative text-center mx-auto')}>
        {title}
      </Text>
    </div>
    <div className={classNames(cardContainerClass,'grid z-20 gap-y-14 mt-[58.77px] items-center justify-center place-content-center  h-screen max-w-[1440px] mx-auto grid-rows-2 grid-cols-3')}>
      {
       CardsList.map((items) => {
          return <>
            <Flippingcard
              containerClasses={classNames(containerCardClasses)}
              backClass={classNames(cardBackClass)}
              front={<>
                <div className={`overflow-hidden w-full h-full shadow-[0px_-1px_64px_#0000000F] rounded-[21px]  ${items.className}`}>
                  <div className={classNames(cardContainerImageClass, 'h-[312px] w-full flex items-center justify-center')}>
                    <Image  src={items.image} alt={"CareerGuide1"} />
                  </div>
                  <div className={classNames(bottomClasses,'pt-[33.33px]  text-[28px] font-bold bg-white pb-[48px] text-center')}>
                    {items.title}
                  </div>
                </div>
              </>}
              back={<>
                <div className={`w-[376px] text-lg   leading-[35px] pl-[31px] pr-[18px] pt-[64.86px] pb-[46.91px] shadow-[0px -1px 64px #0000000F] rounded-[21px] h-[431px] ${backSideClass} ${items.className}`}>
                  {items.desc}
                </div>
              </>}
            />
          </>
        })
      }
    </div>
  </div>
  )
}

export default Face2